export default __webpack_public_path__ + "static/media/linen-texture@2x.81ba4b8c.png";